import i18n from 'i18next';
import { FC } from 'react';
import { ConfigurableMonitoringFormsReportOptions } from './configurableMonitoringFormsReport.options';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { RPDF } from '../react-pdf';
import { FirstPage, MonitoringFormPageWrapper } from '../monitoringForms/monitoringFormsReport.layout';
import { useForm } from 'react-hook-form';
import { DataType } from 'src/components/formEditor/uiEditor/uiEditor';
import { IMonitoringFormConfigDto, IMonitoringFormResultDto } from 'src/services/api/api-client';
import { GeneralFormAnswer } from 'src/features/generalForms/answerPreview/generalFormAnswer';
import { MonitoringFormReportControlsResolver } from './monitoringFormReportControlsResolver';

export const ConfigurableMonitoringFormsReportLayout: FC<ConfigurableMonitoringFormsReportOptions> = (props) => {
  const { t } = useScopedTranslation('Reports.MonitoringReport');

  // TODO: Think about ordering for many form types
  // const orderedMonitoringForms = useMemo(() => {
  //   const arrayCopy = [...props.resultsWithConfig];
  //   arrayCopy.reverse();
  //   return arrayCopy;
  // }, [props.resultsWithConfig]);

  return (
    <RPDF.Document
      language={i18n.language}
      producer={'LM Study'}
      title={t('DocumentTitle')}
      author={props.authorFullName}
      subject={props.studyNumber}
    >
      <FirstPage
        title={t('DocumentTitle')}
        formsTotal={props.resultsWithConfig.length}
        studyName={props.studyName}
        studyNumber={props.studyNumber}
        authorFullName={props.authorFullName}
      />
      {props.resultsWithConfig.map(({ result, config }) => (
        <MonitoringFormPageWrapper
          key={result.formResultId}
          index={result.formResultId}
          title={t('DocumentTitle')}
          formType={config.title}
          created={{
            date: result.createdAt,
            fullName: result.createdBy.fullName,
          }}
          updated={{
            date: result.updatedAt,
            fullName: result.updatedBy.fullName,
          }}
        >
          <MonitoringFormPdfView config={config} result={result} />
        </MonitoringFormPageWrapper>
      ))}
    </RPDF.Document>
  );
};

const MonitoringFormPdfView: FC<{ config: IMonitoringFormConfigDto; result: IMonitoringFormResultDto }> = ({
  config,
  result,
}) => {
  const form = useForm<DataType>({
    defaultValues: result.value as DataType,
  });

  return (
    <GeneralFormAnswer
      form={form}
      resolver={MonitoringFormReportControlsResolver}
      defaultLayout={config.layout}
      initialScoreSections={config.scoreSections ?? []}
      initialVariables={config.variables ?? []}
    />
  );
};
